module.exports = __webpack_public_path__ + "/img/Sot23-Custom-Footprint-iMaqrl.svg";